"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultVehicleFactory = exports.ENGINE_MANUFACTURER = exports.vehiclesListFactory = exports.vehicleFactory = exports.POWER_TRAIN_TYPE = exports.BatteryChargingStatus = void 0;
var BatteryChargingStatus;
(function (BatteryChargingStatus) {
    BatteryChargingStatus["CONNECTED"] = "CONNECTED";
    BatteryChargingStatus["CHARGING"] = "CHARGING";
    BatteryChargingStatus["NOT_CONNECTED"] = "NOT_CONNECTED";
})(BatteryChargingStatus = exports.BatteryChargingStatus || (exports.BatteryChargingStatus = {}));
var POWER_TRAIN_TYPE;
(function (POWER_TRAIN_TYPE) {
    POWER_TRAIN_TYPE["ELECTRIC"] = "Electric";
    POWER_TRAIN_TYPE["DIESEL"] = "Diesel";
})(POWER_TRAIN_TYPE = exports.POWER_TRAIN_TYPE || (exports.POWER_TRAIN_TYPE = {}));
var vehicleFactory = function (config) { return (__assign({ vin: 0, tan: 0, UnitId: '' }, config)); };
exports.vehicleFactory = vehicleFactory;
var vehiclesListFactory = function (config) { return (__assign({ data: [], loading: false }, config)); };
exports.vehiclesListFactory = vehiclesListFactory;
var ENGINE_MANUFACTURER;
(function (ENGINE_MANUFACTURER) {
    ENGINE_MANUFACTURER["DETROIT"] = "DETROIT";
    ENGINE_MANUFACTURER["CUMMINS"] = "CUMMINS";
})(ENGINE_MANUFACTURER = exports.ENGINE_MANUFACTURER || (exports.ENGINE_MANUFACTURER = {}));
var defaultVehicleFactory = function (config) { return (__assign({ ctp: null, customTags: [], engineSerial: null, engineType: null, lastUpdated: null, lastTripEndTs: null, lat: null, lng: null, odometer: null, parameterProfile: null, pkgCEV: false, pkgFuelEconomy: false, pkgFuelSubscription: false, pkgZonarFuelEconomy: false, pkgSafety: false, pkgSafetySubscription: false, pkgZonarSafety: false, pkgDota: false, powerTrainType: POWER_TRAIN_TYPE.DIESEL, remoteUpdates: false, systemTags: [], unitId: null, vin: '', customerName: '', tan: '', hasCumminsEngine: false, manufacturingRLUL: false }, config)); };
exports.defaultVehicleFactory = defaultVehicleFactory;
